module.exports = __webpack_public_path__ + "img/panel-black.927802ba.svg";